import _ from 'lodash'

/**
 * 秒→hh:mm:ss.ss
 * @param sec
 */
export function secToTime (sec: number): string {
  const millisecond = Math.floor(sec % 1 * 100)
  const secInt = Math.floor(sec) // 整数（ミリ秒を切り落とし）

  // 単位ごとの文字列
  const str = {
    millisecond: _.padEnd(String(millisecond), 2, '0'),
    second: _.padStart(String((secInt % 60) % 60), 2, '0'),
    minute: _.padStart(String(Math.floor(secInt / 60) % 60), 2, '0'),
    hour: _.padStart(String(Math.floor(secInt / 3600)), 2, '0'),

    // ES2015（IE11対応）では String.padStart, String.padEnd をサポートしていない
    // millisecond: String(millisecond).padEnd(2, '0'),
    // second: String((secInt % 60) % 60).padStart(2, '0'),
    // minute: String(Math.floor(secInt / 60) % 60).padStart(2, '0'),
    // hour: String(Math.floor(secInt / 3600)).padStart(2, '0'),
  }

  let formatted = `${str.hour}:${str.minute}:${str.second}`

  // 時は"00"なら非表示
  formatted = formatted.replace(/^00:/, '')
  // formatted = formatted.replace(/^00:/, '')

  return formatted
}
